<template>
  <available-components-for-theme4 :specific-components="components" />
</template>
<script lang="ts">
import AvailableComponentsForTheme4 from '~/components/theme4/AvailableComponentsForTheme4.vue';
import { ViewsMixin } from '~/mixins/views.mixin';

export default defineNuxtComponent({
  name: 'Theme4View',

  mixins: [ViewsMixin],

  components: {
    AvailableComponentsForTheme4,
  },

  description:
    'Components that can be used through this theme should be imported here in order to use them dynamically',
});
</script>
